import React from 'react';
import ModalContentWrapper from '../ModalContentWrapper';
const ModalViewChildDiaryEntry = ({ event }) => {

    return (
        <div className="tree-members dairy-modal">
            <ModalContentWrapper>
                <h3 className="dairy-modal-title">{event && event.title}</h3>
                <div className="dairy-modal-entry">{event && event.entry}</div>
            </ModalContentWrapper>
        </div>
    )
}
export default ModalViewChildDiaryEntry;
